import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, Shield, Info, AlertTriangle } from 'lucide-react';

const TermsConditions = () => {
  const { t } = useTranslation();
  const content = t('terms.content', { returnObjects: true });

  const icons = [<CheckCircle2 />, <Shield />, <Info />, <AlertTriangle />];

  return (
    <div className="pt-10">
      <section className="bg-dark-green py-20 text-white text-center">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{t('terms.title')}</h1>
          <p className="text-gold-light font-medium">{t('terms.lastUpdated')}</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-12">
            {content.map((item, index) => (
              <div key={index} className="flex flex-col md:flex-row gap-8 items-start">
                <div className="bg-cream-off p-4 rounded-2xl text-gold-primary flex-shrink-0">
                  {React.cloneElement(icons[index % icons.length], { size: 32 })}
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-dark-green mb-4">{item.heading}</h2>
                  <p className="text-gray-600 leading-relaxed text-lg">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-20 p-10 bg-cream-off rounded-[2rem] border border-gold-primary/20">
            <h3 className="text-2xl font-bold text-dark-green mb-6 text-center">Legal Agreement</h3>
            <p className="text-gray-700 leading-relaxed text-center">
              By using our services, you acknowledge that you have read and understood these Terms & Conditions. 
              These terms may be updated from time to time. Your continued use of the website following any changes 
              constitutes acceptance of those changes.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
